import { getWithAuth, postWithAuth } from '@/util';

export const getMembershipSatisfactionSurvey = async () => {
  return getWithAuth('/web/core/membership-satisfaction/survey');
};

export const submitMembershipSatisfactionSurvey = async ({ score, comment }) => {
  return postWithAuth('/web/core/membership-satisfaction/survey', {
    score,
    comment,
  });
};
